<template>
  <EnquiryFormHeader
    v-if="$store.getters.isRtbFlowPossible && $store.state.step === $store.state.STEPS.dateAndPeople"
    class="border-0 border-t border-grey-300 border-solid pt-6"
  />
  <div v-else-if="$store.getters.isRtbFlowPossible" />
  <ReviewsStars v-else @track="trackReviewClick" />
</template>

<script>
import ReviewsStars from '@/components/ReviewsStars.vue';

import EnquiryFormHeader from './EnquiryFormHeader/EnquiryFormHeader.vue';

export default {
  name: 'EnquiryFormBottom',
  components: {
    EnquiryFormHeader,
    ReviewsStars,
  },
  methods: {
    trackReviewClick() {
      let section = 'event_info';

      if (this.$store.state.step === this.$store.state.STEPS.messageAndCatering) {
        section = 'message';
      } else if (this.$store.state.step === this.$store.state.STEPS.userInfo) {
        section = 'signup';
      }

      this.$store.dispatch('trackGA4Interaction', {
        section,
        element: 'tagvenue_reviews.io_widget',
        interaction: 'click',
      });
    },
  },
};
</script>
